<template>
    <div class="col-sm-6 col-md-4">
        <h2>{{ title_informations[getCurrentLocale] }}</h2>
        <ul class="discover triangle hover row">
            <!-- <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-luggage') }"><a href="/infos-luggage/#/luggage">{{ listpoint_infos_luggage[getCurrentLocale] }}</a></li>
            <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-dangerous-goods') }"><a href="/infos-dangerous-goods/#/dangerous-goods">{{ listpoint_infos_dangerous_goods[getCurrentLocale] }}</a></li>
            <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-prohibited-items') }"><a href="/infos-prohibited-items/#/prohibited-items">{{ listpoint_infos_prohibited_items[getCurrentLocale] }}</a></li>
            <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-additional-services') }"><a href="/infos-additional-services/#/additional-services">{{ listpoint_infos_additional_services[getCurrentLocale] }}</a></li>
            <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-serviceonboard') }"><a href="/infos-serviceonboard/#/serviceonboard">{{ listpoint_infos_serviceonboard[getCurrentLocale] }}</a></li>
            <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-seat-reservation') }"><a href="/infos-seat-reservation/#/seat-reservation">{{ listpoint_infos_seat_reservation[getCurrentLocale] }}</a></li>
            <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-fare-conditions') }"><a href="/infos-fare-conditions/#/fare-conditions">{{ listpoint_infos_fare_conditions[getCurrentLocale] }}</a></li>
            <li class="col-xs-6">
                <a href="#" v-on:click.prevent="call_getwebcomponent('FAQ')">{{ listpoint_faq[getCurrentLocale] }}</a>
            </li> -->
        </ul>

        <br /><h2>{{ title_customerservice[getCurrentLocale] }}</h2>
        <ul class="discover triangle hover row">
            <!-- <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-complaints') }"><a href="/infos-complaints/#/complaints">{{ listpoint_infos_complaints[getCurrentLocale] }}</a></li>
            <li class="col-xs-6" v-bind:class="{ active: getPathName('infos-group-booking') }"><a href="/infos-group-booking/#/group-booking">{{ listpoint_infos_group_booking[getCurrentLocale] }}</a></li> -->
        </ul>










        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal name="size-modal-first"
            transition="nice-modal-fade"
            classes="demo-modal-class"
            :min-width="200"
            :min-height="200"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            xwidth="40%"
            height="auto"
            @before-open="beforeOpen"
            @opened="opened"
            @closed="closed"
            @before-close="beforeClose">
            <div class="size-modal-first-content">
                <h2>{{ webcomponenttype }}</h2>
                <span v-if="sections.length > 1">
                    <div class="toggle-container box" id="accordion1" v-for="(section, index) in sections" :key="index" style="margin-bottom:0px;">
                        <div class="panel style1">
                            <h4 class="panel-title">
                                <a class="collapsed" v-bind:href="'#acc1_' + index" data-toggle="collapse" data-parent="#accordion1">{{ section.title }}</a>
                            </h4>
                            <div class="panel-collapse collapse" v-bind:id="'acc1_' + index">
                                <div class="panel-content">
                                    <span v-html="section.content"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>

                <span v-if="sections.length === 1">
                    <div class="panel style1">
                        <span v-html="sections[0].content"></span>
                    </div>
                </span>
            </div>
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                title_informations: {
                    en: 'Information',
                    de: 'Informationen',
                },
                title_customerservice: {
                    en: 'Customer Service',
                    de: 'Kundenservice',
                },
                listpoint_infos_luggage: {
                    en: 'Luggage',
                    de: 'Gepäck',
                },
                listpoint_infos_dangerous_goods: {
                    en: 'Dangerous Goods',
                    de: 'Gefährliche Güter',
                },
                listpoint_infos_prohibited_items: {
                    en: 'Prohibited Items',
                    de: 'Verbotene Gegenstände',
                },
                listpoint_infos_additional_services: {
                    en: 'Additional Services',
                    de: 'Zusatzleistungen',
                },
                listpoint_infos_serviceonboard: {
                    en: 'Service on board',
                    de: 'Service an Board',
                },
                listpoint_infos_seat_reservation: {
                    en: 'Seat Reservation',
                    de: 'Sitzplatzreservierung',
                },
                listpoint_infos_fare_conditions: {
                    en: 'Fare Conditions',
                    de: 'Tarifbestimmungen',
                },
               listpoint_infos_complaints: {
                    en: 'Complaints',
                    de: 'Reklamationen',
                },
               listpoint_infos_group_booking: {
                    en: 'Group Booking',
                    de: 'Gruppenbuchung',
                },
                listpoint_faq : {
                    en: 'FAQ',
                    de: 'FAQ',
                },
                // >>> -------------------------- Modal
                webcomponenttype: '', // ABB/FAQ aso.
                sections: [], // data
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Methods */
        methods: {


            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/site/getwebcomponent/'
            *
            * Desc:
            * Note:
            *
            * @param {string} comptype (kind of Component)
            * @param
            * @return
            */
            call_getwebcomponent: function (comptype) {

                var me = this,
                    hdrs = '';


                me.$toc('>>> shared/footer/FirstRow.vue >>> call_getwebcomponent');
                // >>> 1. Builds Object ----------------------------------------
                const requestParamObject = {
                    name: comptype
                };


                // >>> #267, Translation ---------------------------------------
                if (comptype === 'FAQ') {
                    this.webcomponenttype = this.listpoint_faq[this.getCurrentLocale];
                } else {
                    this.webcomponenttype = comptype; // remember
                }


                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/site/getwebcomponent/', requestParamObject)
                    .then(function(response) { // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.$modal.show('size-modal-first', { data: response.data });
                                me.$vp_um();
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_getwebcomponent()




            /******************************************************************* 'Utilities - Common'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getPathName()
            *
            * Desc:
            * Note:
            *
            * @param {string} pathname ()
            * @param
            * @return
            */
            getPathName: function (pathname) {

                var me = this,
                    currentUrl = window.location.pathname,
                    currentUrl = currentUrl.slice(1,-1);


                // me.$toc('>>> shared/footer/LanguageList.vue >>> getPathName');
                if (pathname === currentUrl) {
                    return true;
                } else {
                    return false;
                }

            }, // eof getPathName()





            /*******************************************************************
            * Modals:
            *******************************************************************/
            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc:
            * Note: Catches 'data' Object from $modal.show.
            *
            */
            beforeOpen (event) {

                this.sections = event.params.data.sections;

            }, // eof beforeOpen()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* Modal */
    .size-modal-first-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
        padding-right: 50px;
    }
    .v--modal-overlay[data-modal="size-modal"] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;

    }
    .demo-modal-class {
        border-radius: 5px;
        background: #F7F7F7;
        box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
    }
</style>